import InAppSalesChatService from '../InAppSalesChatService';
import { defaultZendeskSettings, initializeZendeskApi } from '../ZendeskService/ZendeskService';
import { ZendeskSettings } from '../ZendeskService/types';
import { hasZendeskApiInitialized } from '../ZendeskService/utils';

import { setSupportChatStatus } from './reducer';
import { selectSupportChatStatus } from './selectors';
import { InAppChatService, SupportChatStatus } from './types';

/**
 * @deprecated Use InAppSalesChatService.show or window.(top.)services.inAppSalesChat.show instead.
 */
export const show = InAppSalesChatService.show;
/**
 * @deprecated Use InAppSalesChatService.hide or window.(top.)services.inAppSalesChat.hide instead
 */
export const hide = InAppSalesChatService.hide;

function initialize() {
  initializeZendeskApi().then((zE) => {
    zE('webWidget:on', 'chat:status', (status: SupportChatStatus) => {
      window.store.dispatch(setSupportChatStatus(status));
      if (status === SupportChatStatus.Offline) {
        zE('webWidget', 'chat:end');
      }
    });
  });
}

function openContactForm() {
  if (!hasZendeskApiInitialized(window)) {
    return;
  }

  window.zE(
    'webWidget',
    'updateSettings',
    Object.assign<{}, ZendeskSettings, Partial<ZendeskSettings>>({}, window.zESettings ?? defaultZendeskSettings, {
      webWidget: {
        chat: {
          suppress: true,
        },
        contactForm: {
          suppress: false,
        },
        helpCenter: {
          suppress: true,
        },
      },
    }),
  );

  window.zE('webWidget', 'show');
  window.zE('webWidget', 'open');
}

function openSupportChat() {
  if (!hasZendeskApiInitialized(window)) {
    return;
  }

  window.zE(
    'webWidget',
    'updateSettings',
    Object.assign<{}, ZendeskSettings, Partial<ZendeskSettings>>({}, window.zESettings ?? defaultZendeskSettings, {
      webWidget: {
        chat: {
          suppress: false,
        },
        contactForm: {
          suppress: true,
        },
        helpCenter: {
          suppress: true,
        },
      },
    }),
  );

  window.zE('webWidget', 'show');
  window.zE('webWidget', 'open');
}

function open() {
  const supportChatStatus = selectSupportChatStatus(window.store.getState());

  if (supportChatStatus === SupportChatStatus.Offline) {
    openContactForm();
  } else {
    openSupportChat();
  }
}

const ZendeskInAppChatService: InAppChatService = {
  initialize,
  open,
  show,
  hide,
};

export default ZendeskInAppChatService;
